var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"icon-tooltip-message"},[_c('i',{staticClass:"pi pi-info-circle",attrs:{"id":_vm.targetId}}),_c('b-tooltip',{attrs:{"target":_vm.targetId,"triggers":"hover"}},[_vm._v(" Put the word ALL to add ALL states on this country ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }